import ControlBar from './ControlBar';

export default ControlBar;
